/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Portals_ExportInputs */

const cs_property_portals_export = /** @type {(inputs: Property_Portals_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na portály`)
};

const en_property_portals_export = /** @type {(inputs: Property_Portals_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal export`)
};

/**
* | output |
* | --- |
* | "Portal export" |
*
* @param {Property_Portals_ExportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_portals_export = /** @type {((inputs?: Property_Portals_ExportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Portals_ExportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_portals_export(inputs)
	return cs_property_portals_export(inputs)
});